export const CDP_SECTIONS = [
  { id: 'cdp-what', label: 'What are Customer Data Platforms?' },
  { id: 'cdp-why', label: 'Why Should Marketers Care?' },
  { id: 'cdp-intro', label: 'Introducing Antsomi CDP 365' },
  { id: 'cdp-benefits', label: 'The Big Benefits of a CDP' },
  { id: 'cdp-why-antsomi', label: 'Why Marketers Choose Antsomi CDP 365' },
  { id: 'cdp-case', label: "Lessons from Coffee Brand's Success" },
  { id: 'cdp-takeaway', label: 'Takeaway For Marketers' },
]
